/**
 *
 * @file CORE script
 * @description customised for individual builds
 * @copyright JG Media Limited
 * @author JG Media [jgmedia.co.uk]
 * @version 1.0
 * @module core-script-custom
 *
 */

import smoothscroll from 'smoothscroll-polyfill';
import { DateTime } from 'luxon';
window.DateTime = DateTime; //set global

const isIos = () => {
	const userAgent = window.navigator.userAgent.toLowerCase();
	return /iphone|ipad|ipod/.test(userAgent);
}

// Detects if device is in standalone mode
const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

(function($) {

	//--------------------------------------------------------
	// PWA
	//--------------------------------------------------------

	/* Only register a service worker if it's supported */
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.register('/service-worker.js').then(function(registration) {
			// Registration was successful
			console.log('JG: service worker registered');
		}, function(err) {
			// registration failed :(
			console.log('JG: service worker registration failed: ', err);
		}).catch(function(err) {
			console.log(err);
		});

	}

	//--------------------------------------------------------
	// OTHER
	//--------------------------------------------------------

	jQuery(document).ready(function() {

		// Checks if should display install popup notification:
		if (isIos() && !isInStandaloneMode()) {

			jQuery('#ios-installation-prompt').show();
			jQuery('#main-footer').addClass('install-prompt');

		}

		// kick off the smooth scroll polyfill!
		smoothscroll.polyfill();

		//fire up sliders
		var sliders = jQuery('.testimonial-slider');

		sliders.each(function(index, slider) {

			if (!slider.classList.contains('slick-initialized')) {

				slider = jQuery(slider);

				//init events must be set before firing up the slider
				slider.on('init', function() {

					//do things after the slider is setup
					console.log('CORE: slider loaded: ' + slider.attr('class'));

					//add dot icons
					jQuery('.slick-dots li button').html('<i class="fas fa-circle"></i>');

				});

				lcFunctions.testimonialSliderInit(slider);

			}

		});

		jQuery('.lc-show-pw').click(function(){

			document.querySelectorAll('#user_pass').forEach(input => {

				if(input.type === 'password') input.type = 'text';
				else if(input.type === 'text') input.type = 'password';

			})


		})

	});

})(jQuery);